import { render, staticRenderFns } from "./agv-articles-list.vue?vue&type=template&id=36d83986&scoped=true&lang=pug&"
import script from "./agv-articles-list.vue?vue&type=script&lang=js&"
export * from "./agv-articles-list.vue?vue&type=script&lang=js&"
import style0 from "./agv-articles-list.vue?vue&type=style&index=0&id=36d83986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d83986",
  null
  
)

export default component.exports